import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

const todoRouter: RouteConfig = {
  path: '/todo',
  component: Layout,
  meta: {
    title: 'route.todo',
    icon: 'iconrenwu0',
    activeMenu: ['/todo'],
    alwaysShow: false,
  },
  children: [
    {
      path: '/todo/index',
      name: 'Todo',
      component: () => import('@/views/todo/index.vue'),
      meta: {
        title: 'route.todoList',
        activeMenu: ['/todo', '/todo/index'],
        breadcrumb: [
          {title: 'route.todoList', path: '/todo/index'},
        ],
      },
    },
    {
      path: '/todo/grab',
      name: 'GrabTodo',
      component: () => import('@/views/todo/grab/index.vue'),
      meta: {
        title: 'todo.grab',
        noCache: true,
        activeMenu: ['/todo', '/todo/grab'],
        breadcrumb: [
          {title: 'todo.grab', path: '/todo/grab'},
        ],
      },
    },
    {
      path: '/todo/create',
      name: 'CreateTodo',
      props: true,
      component: () => import('@/views/todo/createTodo.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/todo/index'],
        title: 'route.createTodo',
        noCache: true,
        breadcrumb: [
          {title: 'route.todoList', path: '/todo/index'},
          {title: 'route.createTodo', path: '/todo/create'},
        ],
      },
    },
  ],
};

export default todoRouter;
